<template>
  <div
    class="is-flex is-align-items-center is-justify-content-center"
    style="height: 75vh"
  >
    <div class="is-relative has-text-centered">
      <h1 class="title has-text-grey-light">Selamat Datang</h1>
      <h4 class="subtitle has-text-grey-light">{{ $auth.user().name }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dashboard"
};
</script>
